var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTrendDownward(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 12,
    viewBox: "0 0 8 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.66526 7.83984C7.75687 8.04609 7.71347 8.28516 7.55437 8.44922L4.2758 11.8242C4.16731 11.9367 4.01544 12 3.85633 12C3.69723 12 3.54535 11.9367 3.43687 11.8242L0.158296 8.44922C-0.000810767 8.28516 -0.0442036 8.04609 0.0474035 7.83984C0.139011 7.63359 0.346332 7.5 0.577761 7.5H2.31348V0.75C2.31348 0.335156 2.65821 0 3.0849 0H4.62776C5.05446 0 5.39919 0.335156 5.39919 0.75V7.5H7.1349C7.36633 7.5 7.57365 7.63359 7.66526 7.83984Z",
    fill: "#E8507E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrendDownward);
export default __webpack_public_path__ + "static/media/trend-downward.4f914a6c3e9d05ea311fcc292059718e.svg";
export { ForwardRef as ReactComponent };